import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useMedia } from 'react-use'
import { Button, Drawer, Dropdown } from 'antd'
import { DownOutlined, MenuOutlined } from '@ant-design/icons'
import { Trans, useTranslation } from 'next-i18next'
import useToken from 'antd/lib/theme/useToken'

import { useGetUserInfoQuery } from '@/redux/api/userApi'

import { Menu } from './Menu'

type MenuButtonProps = {
  className?: string
}

export const MenuButton: FC<MenuButtonProps> = ({ className }) => {
  const { t } = useTranslation('common')

  const [, { screenLG }] = useToken()

  const isUnderLargeScreen = useMedia(`(max-width: ${screenLG}px)`, false)

  const [isOpenedDropdown, setIsOpenedDropdown] = useState(false)

  const [isOpenedDrawer, setIsOpenedDrawer] = useState(false)

  useEffect(() => {
    setIsOpenedDropdown(false)
    setIsOpenedDrawer(false)
  }, [isUnderLargeScreen])

  const { data: userInfo } = useGetUserInfoQuery()

  const isPaidUser =
    !!userInfo && (userInfo.enterprise || userInfo.plan !== 'none')

  return (
    <MenuButtonContainer className={className}>
      {/* 
        큰 화면인 경우
      */}
      <StyledDropdown
        trigger={['click']}
        open={isOpenedDropdown}
        onOpenChange={(open) => setIsOpenedDropdown(open)}
        dropdownRender={() => <Menu />}
        overlayStyle={{
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0px 4px 4px 0px #00000040',
          borderRadius: '4px',
          backgroundColor: 'white',
        }}
        destroyPopupOnHide
      >
        <DropdownButton type="link">
          <div>
            {!isPaidUser && (
              <Trans
                i18nKey={
                  'Please enjoy exploring other <highlight>FREE</highlight> tools!'
                }
                components={{
                  highlight: <span className="highlight" />,
                }}
              />
            )}
            {isPaidUser && t('Please enjoy exploring other tools!')}
          </div>
          <DownOutlined />
        </DropdownButton>
      </StyledDropdown>

      {/* 
        작은 화면인 경우
      */}
      <HamburgerButton type="text" onClick={() => setIsOpenedDrawer(true)}>
        <MenuOutlined />
      </HamburgerButton>

      <Drawer
        onClose={() => setIsOpenedDrawer(false)}
        open={isOpenedDrawer}
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <Menu />
      </Drawer>
    </MenuButtonContainer>
  )
}

const MenuButtonContainer = styled.div``

const StyledDropdown = styled(Dropdown)`
  @media (max-width: ${({ theme }) => theme.screenLG}px) {
    display: none;
  }
`

const DropdownButton = styled(Button)`
  display: flex;
  gap: 12px;
  align-items: center;

  div {
    font-size: 14px;
    line-height: 20px;
  }

  span.highlight {
    font-weight: 700;
  }

  @media (max-width: ${({ theme }) => theme.screenLG}px) {
    display: none;
  }
`

const HamburgerButton = styled(Button)`
  align-items: center;
  justify-content: center;

  color: #53677b;

  display: none;

  @media (max-width: ${({ theme }) => theme.screenLG}px) {
    display: flex;
  }
`
